import { API_URL, BUSINESS_API_TOKEN } from '../../config';
import { applyPreproductionSettings } from '../../utils/PreproductionSettings';

const fetchWithAuth = async (url: string, lang: string) => {
  url = applyPreproductionSettings(url);
  if (lang.includes('zh')) {
    url += url.includes('?') ? '&locale=zh-Hant-HK&fallbackLocale=false' : '?locale=zh-Hant-HK&fallbackLocale=false';
  }
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${BUSINESS_API_TOKEN}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const fetchBusiness = async (lang: string) => {
  try {
    const businessResponse = await fetchWithAuth(
      `${API_URL}/business?populate=Banner.BannerImage,Banner.BannerImageTab,Banner.BannerImageMob,Banner.Button,TabbedContent.ImageThumbnail,TabbedContent.TabImage,LocationFinderSection.BottomBannerImage,LocationFinderSection.BottomBannerImageTab,LocationFinderSection.BottomBannerImageMob,LocationFinderSection.BannerButtonLink,LocationFinderSection.Banners.BackgroundImage,LocationFinderSection.Banners.ChannelLogo,LocationFinderSection.Banners.BottomImage,ContactSection.Icon.IconImage,FormFields,GA,SEO.MetaImage&pagination[limit]=-1`,
      lang
    );

    const business = businessResponse.data;

    console.log('fetchBusiness API Response:', business);
    return business;
  } catch (error) {
    console.error('Error fetching packs.', error);
    return null;
  }
};